import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-108879fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center p-2" }
const _hoisted_2 = { class: "m-0" }
const _hoisted_3 = { class: "m-0" }
const _hoisted_4 = { class: "justify-content-right" }
const _hoisted_5 = { class: "container" }
const _hoisted_6 = {
  key: 0,
  class: "row justify-content-center align-items-center"
}
const _hoisted_7 = {
  key: 1,
  class: "row justify-content-center align-items-center"
}
const _hoisted_8 = {
  key: 0,
  class: "col-4 align-items-center"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "m-0" }, "Add List:", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "col-4 align-items-center"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "col-4 align-items-center" }

import { ref, Ref, onMounted } from "vue";
import { useRoute } from 'vue-router';
import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBIcon,
    MDBCardTitle,
    MDBListGroup,
    MDBListGroupItem,
    MDBContainer,
    MDBFooter,
    MDBSpinner
} from "mdb-vue-ui-kit";
import { addListToGroup, getAllLists, getListGroup, parseListKey, putList, removeListFromGroup } from '@/functions/store';
import { extractRef } from '@/functions/utility';
import { List } from '@/types/List';
import { ListGroup } from "@/types/ListGroup";
import { downloadList, uploadList } from "@/functions/list";
import { useEventsBus } from '@/functions/utility';
import VerifyModal from "@/components/VerifyModal.vue";
import { ModalOptions } from "@/components/VerifyModal.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { emit } = useEventsBus();
const route = useRoute();

// setup universal vars
const listGroup = ref<ListGroup>({
    name: '',
    lists: []
});
const modal = ref(null);
const allLists = ref<List[]>([]);
const addList = ref('');
const processingList = ref(false);
const listGroupKey = route.params.groupKey;

/**
* Get Lists and list group
*/
async function getData() {
    const storedGroup = await getListGroup(listGroupKey as string) as unknown as ListGroup[];
    listGroup.value = storedGroup[0];
    const storedLists = await getAllLists();
    allLists.value = storedLists;
    addList.value = storedLists[0].name;
}

/**
* Remove List with listname from Set of Lists
*
* @param name name of list to remove
*/
async function removeList(name: string) {
    const currentLists = listGroup.value.lists;

    for (let i = 0; i < currentLists.length; i++) {
        const list = currentLists[i];

        if (list.name === name) {
            currentLists.splice(i, 1);
            break;
        }
    }

    listGroup.value.lists = currentLists;
    await removeListFromGroup(listGroup.value.name, name);
}

async function addNewList() {
    const addResp = await addListToGroup(listGroup.value.name, addList.value);

    const grpResp = await getListGroup(listGroup.value.name);
    listGroup.value = grpResp[0];
}

async function downloadLists() {
    processingList.value = true;
    const listGroupObj = extractRef(listGroup);
    const lists: List[] = listGroupObj.lists;

    for (let i = 0; i < lists.length; i++) {
        const list = lists[i];

        let downResp;
        try {
            downResp = await downloadList(list);
        } catch (error: any) {
            console.error(error);
            emit('newAlert', 'Unable to continue downloading lists: ' + error.message);
            return false;
        }

        if (downResp.success === false) {
            const continueDownload = await notifyFailure('download', list, downResp.message);
            if (continueDownload === false) break;
        } else {
            // store downloaded list
            try {
                const putResp = await putList(downResp.data);
                if (putResp === null) {
                    const continueDownload = await notifyFailure('download', list, 'Failed to store list');
                    if (continueDownload === false) break;
                }
            } catch (error: any) {
                console.error(error);
                const continueDownload = await notifyFailure('download', list, error.message);
                if (continueDownload === false) break;
            }
        }
    }

    await getData();
    processingList.value = false;
}

async function uploadLists() {
    processingList.value = true;
    const lists = listGroup.value.lists;

    for (let i = 0; i < lists.length; i++) {
        const list = lists[i];

        let upResp;
        try {
            upResp = await uploadList(list);
        } catch (error) {
            console.error(error);
            processingList.value = false;
            return false;
        }

        if (upResp.success === false) {
            const continueUpload = await notifyFailure('upload', list, upResp.message);
            if (continueUpload === false) break;
        }
    }

    processingList.value = false;
}

async function notifyFailure(type: 'upload' | 'download', list: List, message = '') {
    if (modal.value === null) return false;

    const upType = type.charAt(0).toUpperCase() + type.slice(1);
    const opts: ModalOptions = {
        title: upType + ' Failed',
        content: `There was an error when trying to ${type} the list "${list.name}"${ message !== '' ? ': ' + message : '' }. Continue to other lists in the group?`,
        verify: true
    };

    return modal.value.showModal(opts);
}

onMounted(async () => {
    await getData();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(VerifyModal, {
      ref: (_value, _refs) => {
        _refs['modal'] = _value
        modal.value = _value
      }
    }, null, 512),
    _createVNode(_unref(MDBContainer), { class: "mt-4 mb-8" }, {
      default: _withCtx(() => [
        _createVNode(_unref(MDBCard), { class: "mt-3" }, {
          default: _withCtx(() => [
            _createVNode(_unref(MDBCardBody), null, {
              default: _withCtx(() => [
                _createVNode(_unref(MDBCardTitle), { class: "my-3 h1" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(listGroup.value.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(MDBListGroup), null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listGroup.value.lists, (list) => {
                      return (_openBlock(), _createBlock(_unref(MDBListGroupItem), {
                        key: list.name
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("h4", _hoisted_2, [
                              _createVNode(_unref(MDBIcon), {
                                icon: "bars",
                                iconStyle: "fas"
                              }),
                              _createTextVNode(" " + _toDisplayString(list.name), 1)
                            ]),
                            _createElementVNode("p", _hoisted_3, _toDisplayString(list.articles.length) + " articles", 1),
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_unref(MDBBtn), {
                                color: "primary",
                                floating: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_router_link, {
                                    to: { name: 'List', params: { listKey: _unref(parseListKey)(list.name) } }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(MDBIcon), {
                                        icon: "edit",
                                        iconStyle: "fas"
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["to"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_unref(MDBBtn), {
                                color: "danger",
                                onClick: ($event: any) => (removeList(list.name)),
                                floating: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(MDBIcon), {
                                    icon: "trash",
                                    iconStyle: "fas"
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(MDBFooter), {
      bg: "primary",
      text: ['white', 'center'],
      class: "fixed-bottom p-3"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (processingList.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(_unref(MDBSpinner))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (addList.value != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
                  : _createCommentVNode("", true),
                (addList.value != '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("select", {
                        id: "listSelect",
                        class: "form-select",
                        "aria-label": "List to add to Group",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((addList).value = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allLists.value, (list) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: 'list-' + _unref(parseListKey)(list.name),
                            value: list.name
                          }, _toDisplayString(list.name), 9, _hoisted_12))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, addList.value]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_unref(MDBBtn), {
                    color: "success",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (addNewList())),
                    floating: "",
                    class: "me-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(MDBIcon), {
                        icon: "plus",
                        iconStyle: "fas",
                        size: "2x"
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(MDBIcon), {
                    onClick: downloadLists,
                    icon: "cloud-download-alt",
                    iconStyle: "fas",
                    size: "2x",
                    class: "me-4",
                    title: "Download and save Lists to get updates"
                  }),
                  _createVNode(_unref(MDBIcon), {
                    onClick: uploadLists,
                    icon: "cloud-upload-alt",
                    iconStyle: "fas",
                    size: "2x",
                    class: "me-4",
                    title: "Upload Lists to publish changes"
                  })
                ])
              ]))
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})